import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px;
  background: ${(props) =>
    props.theme.colors?.backgroundSecondary || "#F9FAFB"};
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.colors?.text || "#111827"};
  margin: 0;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  margin: 0;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BlastButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  background: ${(props) => 
    props.disabled 
      ? props.theme.colors?.backgroundSecondary || "#E5E7EB"
      : props.theme.colors?.primary || "#3B82F6"
  };
  color: ${(props) => 
    props.disabled 
      ? props.theme.colors?.textSecondary || "#9CA3AF"
      : "#FFFFFF"
  };
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${(props) => props.theme.colors?.primaryDark || "#2563EB"};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Content = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 0;
`;

export const TabsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const TabContent = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  min-height: 0;
`;

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  background: ${(props) => props.theme.colors?.backgroundSecondary || "#F9FAFB"};
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StepNumber = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  border-radius: 50%;
  background: ${(props) => 
    props.$isActive 
      ? props.theme.colors?.primary || "#3B82F6"
      : props.$isCompleted
        ? props.theme.colors?.success || "#059669"
        : props.theme.colors?.backgroundSecondary || "#E5E7EB"
  };
  color: ${(props) => 
    props.$isActive || props.$isCompleted
      ? "#FFFFFF"
      : props.theme.colors?.textSecondary || "#6B7280"
  };
`;

export const StepLabel = styled.span`
  font-size: 14px;
  font-weight: ${(props) => (props.$isActive ? 600 : 400)};
  color: ${(props) => 
    props.$isActive 
      ? props.theme.colors?.text || "#111827"
      : props.theme.colors?.textSecondary || "#6B7280"
  };
`;

export const StepDivider = styled.div`
  width: 40px;
  height: 1px;
  background: ${(props) => props.theme.colors?.border || "#E5E7EB"};
`;

export const ErrorBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin: 16px 24px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.errorLight || "#FEE2E2"};
  color: ${(props) => props.theme.colors?.error || "#DC2626"};
  font-size: 14px;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  button {
    margin-left: auto;
    padding: 4px 8px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: ${(props) => props.theme.colors?.error || "#DC2626"};
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 999;
`;
